// extracted by mini-css-extract-plugin
module.exports = {"table":"ItemsTable_table__3FOmb","selectAll":"ItemsTable_selectAll__SM-zi"};